<template>
    <div class="modal-card upload-model">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered is-size-3" v-if="user_id != -1">
                Editar relación del usuario con la empresa
            </h3>
            <h3 class="modal-card-title has-text-centered is-size-3" v-else>
                Añadir un usuario
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="section_analysts">
            <div v-if="user_id != -1" role="navigation" aria-label="main navigation" class="analyst_users">
                <div class="selected_user">
                    {{ user_email }}
                </div>
            </div>
            <table v-else>
                <tr>
                    <td class="filtrar_text">Filtrar usuarios:</td>
                    <td><input type="text" v-model="filterUsers" /></td>
                </tr>
            </table>
        </section>
        <section class="section_companies">
            <div class="companies">
                <table class="table_companies">
                    <tr v-for="company in companies_list" v-bind:key="company.id" class="company_row"
                        @click="selectRow(company)">
                        <td>
                            <button :class="[
                                'first_button',
                                { unselected_button: !company.selected },
                                { selected_button: company.selected }]">
                                {{ company.selected ? " ✔" : "" }} </button>
                        </td>
                        <td class="company_td" v-if="user_id == -1">
                            <div class="nobreak">
                                {{ company.email }}
                            </div>
                        </td>
                        <td class="company_td" v-else>
                            <div class="nobreak">
                                {{ company.rut }}
                            </div>
                        </td>
                        <td class="company_td">
                            <div>
                                {{ company.name }}
                            </div>
                        </td>
                        <td class="company_td role_td" v-if="user_id != -1" @click.stop>
                            <select v-model="company.role" class="role_select"
                                aria-label="Rol del usuario en la empresa">
                                <option value="">Sin rol</option>
                                <option v-for="option in roleOptions" :key="option.value"
                                    :value="option.value">
                                    {{ option.label }}
                                </option>
                            </select>
                        </td>
                    </tr>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary" :disabled="loading" role="button" @click="grabarEmpresasAnalista()">
                Grabar
            </button>
        </footer>
    </div>
</template>

<script>
import { companies_per_user, save_analysts_per_company, save_companies_analyst, users_of_company } from "@/api/carteraAnalista";
import { consoleHandlerError, notificate } from "@/utils/message";
import { ROLE_OPTIONS } from "@/utils/roles";

export default {
    name: "AssignUsers",
    data() {
        return {
            companies_list: [],
            raw_analistas: [],
            filterUsers: "",
            loading: false,
            roleOptions: ROLE_OPTIONS,
        };
    },
    props: {
        user_id: {
            type: Number,
            required: true,
        },
        company_id: {
            type: Number,
            required: true,
        },
        user_email: {
            type: String,
            required: true,
        },
    },
    components: {
    },
    computed: {
    },
    methods: {
        filterData() {
            if (this.filterUsers == "") {
                this.companies_list = this.raw_analistas;
            } else {
                const normalized_filter = this.filterUsers.replace(/\s+/g, "").toUpperCase();
                const filtered_analistas = this.raw_analistas.filter(
                    (user) => {
                        const normalized_text = user['all_text'].replace(/\s+/g, "").toUpperCase();
                        user['all_text'].includes(this.filterUsers.toUpperCase())
                        return normalized_text.includes(normalized_filter);
                    }
                );
                this.companies_list = filtered_analistas;
            }
        },
        selectRow(company) {
            company['selected'] = !company['selected'];
        },
        async grabarEmpresasAnalista() {
            if (this.user_id != -1) {
                this.loading = true;
                save_companies_analyst(this.user_id, this.companies_list).then(
                    () => {
                        notificate(
                            "Se grabaron las compañias del usuario.",
                            "is-success is-light",
                            "is-top-right",
                            false,
                            5000
                        );
                        this.loading = false;
                    }
                ).catch(() => {
                    this.loading = false;
                    consoleHandlerError('Error al grabar las compañias del usuario.');
                }).finally(() => {
                    this.$emit("close");
                })
            } else {
                this.loading = true;
                save_analysts_per_company(this.company_id, this.companies_list).then(
                    () => {
                        notificate(
                            "Se grabaron los usuarios de la compañia.",
                            "is-success is-light",
                            "is-top-right",
                            false,
                            5000
                        );
                        this.loading = false;
                    }
                ).catch(() => {
                    this.loading = false;
                    consoleHandlerError('Error al grabar los usuarios de la compañia.');
                }).finally(() => {
                    this.$emit("close");
                });
            }
        },
    },
    mounted() {
        if (this.user_id == -1) {
            users_of_company(this.company_id).then((response) => {
                this.raw_analistas = response.data['companies'];
                this.companies_list = this.raw_analistas;
            }).catch(() => {
                consoleHandlerError('Error al recuperar los usuarios de la compañia.');
            });
        } else {
            companies_per_user(this.user_id).then((response) => {
                // Garantizamos la key `role` upfront: v-model sobre company.role
                // necesita que exista para ser reactivo en Vue 2 (sin $set).
                const companies = response.data['companies'].map(
                    (company) => ({ ...company, role: company.role || "" })
                );
                this.raw_analistas = companies;
                this.companies_list = companies;
            }).catch(() => {
                consoleHandlerError('Error al recuperar las compañias del usuario.');
            });
        }
    },
    watch: {
        filterUsers() {
            this.filterData();
        }
    },
};
</script>
<style scoped>
.selected_user {
    font-weight: 900;
}

.upload-model {
    text-align: center;
    width: 100%;
}

.analyst_users {
    padding-top: 10px;
    padding-left: 30px;
}

.nombre_email {
    font-size: 80%;
}

.company_td {
    vertical-align: middle;
    border: 0px solid #000000;
    padding: 0 5px 0 5px;
}

.section_analysts {
    background-color: #FcFdFf;
    display: flex;
    justify-content: center;
    align-items: center;
}

.section-filter {
    height: 50px;
    overflow: visible;
    background-color: #FbFcFe;
    padding: 5px 0 5px 0;
}

.section_companies {
    background-color: #F8F9Fd;
    overflow: auto;
    text-align: center;
    width: 100%;
    min-height: 400px;
}

.table_companies {
    text-align: center;
}

.companies {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}


.centered_div {
    display: flex;
    justify-content: center;
    align-items: center;
}

.filtrar_text {
    padding-right: 5px;
}

.modal-card-body {
    padding-top: 10px !important;
}

.selected_company {
    background-color: #ffff00 !important;
    border-color: #000000 !important;
}

.company_button {
    cursor: pointer;
    justify-content: center;
    border: 1px solid #444444;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    padding: 2%;
    margin: 2px;
}

.company_button:hover {
    background-color: #fffff3;
    transform: translateY(-2px);
}

.company_button:active {
    transform: translateY(1px);
}

.nobreak {
    white-space: nowrap;
}

.selected_analyst {
    background-color: #ffff00;
    border-color: #000000 !important;
    color: #000000;
}

.candidate_analyst {
    border: 1px solid #dddddd;
}

.added_analyst {
    background-color: #eeee99;
}

.added_analyst:after {
    content: '+';
    padding-left: 6px;
    font-size: 130%;
    font-weight: bold;
    -webkit-text-stroke: white 1px;
}

.deleted_analyst {
    background-color: #ffffbb !important;
    text-decoration: line-through;
    text-decoration-thickness: 2px;
}

.deleted_analyst:after {
    content: '-';
    padding-left: 6px;
    font-size: 130%;
    font-weight: bold;
    -webkit-text-stroke: white 1px;
}

.first_button {
    width: 40px;
    height: 40px;
    margin: 3px;
    transition: background-color 0.15s ease, border 0.15s ease;
}

.unselected_button {
    background-color: #f1f1f1;
    border: 2px inset #dddddd;
}

.selected_button {
    border-radius: 4px;
    color: #ffffff;
    font-weight: bold;
    background-color: #3333ff;
    border: 4px outset #dddddd;
}

.company_row {
    background-color: #ffffff;
    border: 1px solid#000000;
}
</style>